import React from "react";
import ReactDOM from "react-dom";
import { FloatingPortalContext } from "./PortalHelpers";

export class ADMPortal extends React.PureComponent<{ children: React.ReactNode, title: string, active: boolean, onClose?: () => void }> {
   containerEl: HTMLDivElement;
   externalWindow: Window | null;
   uniqueNumber: number;

   constructor(props: { children: React.ReactNode, onClose?: () => void, active: boolean, title: string }) {
      super(props);
      // STEP 1: create a container <div>

      this.uniqueNumber = Math.random() * 1000 % 1000;
      this.containerEl = document.createElement('div');
      this.externalWindow = null;
   }

   render() {
      // Only render portal if active
      if (!this.props.active) return this.props.children as React.ReactElement;
      return ReactDOM.createPortal(
         <FloatingPortalContext.Provider value={{ root: this.externalWindow?.document.body || null }}>
            {this.props.children}
         </FloatingPortalContext.Provider>
         , this.containerEl);
   }

   componentDidMount() {
      if (this.props.active) {
         this.openWindow();
      }
   }

   componentDidUpdate(prevProps: { active: boolean }) {
      if (this.props.active && !prevProps.active) {
         this.openWindow();
      } else if (this.props.active && prevProps.active) {
         this.focusWindow();
      } else if (!this.props.active && prevProps.active) {
         this.closeWindow();
      }
   }

   componentWillUnmount() {
      this.closeWindow();
   }

   focusWindow() {
      if (this.externalWindow) {
         this.externalWindow.focus();
      }
   }

   openWindow() {
      // STEP 3: open a new browser window and store a reference to it
      // positionShouldBeCalculated = true;

      this.externalWindow = window.open('', `${this.props.title} - ${this.uniqueNumber}`, 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=400,left=200,top=200');

      // STEP 4: append the container <div> (that has props.children appended to it) to the body of the new window
      this.externalWindow?.document.body.appendChild(this.containerEl);
      this.externalWindow?.document.body.classList.add("POPOUT_WINDOW")

      if (this.externalWindow?.document)
         this.externalWindow.document.title = this.props.title;

      copyStyles(document, this.externalWindow?.document);

      this.externalWindow?.addEventListener('beforeunload', () => {
         this.props.onClose?.();
      });
   }

   closeWindow() {
      if (this.externalWindow) {
         this.externalWindow?.close();
         this.externalWindow = null;
      }
   }
}

function copyStyles(sourceDoc, targetDoc) {
   Array.from(sourceDoc.styleSheets).forEach((styleSheet: unknown) => {
      try {
         if (isCssStyleSheet(styleSheet)) {
            const newStyleEl = sourceDoc.createElement('style');

            Array.from(styleSheet.cssRules).forEach(cssRule => {
               newStyleEl.appendChild(sourceDoc.createTextNode(cssRule.cssText));
            });

            targetDoc.head.appendChild(newStyleEl);
         } else if (typeof styleSheet === 'object' && styleSheet !== null && 'href' in styleSheet) {
            const newLinkEl = sourceDoc.createElement('link');
            newLinkEl.rel = 'stylesheet';
            newLinkEl.href = styleSheet.href;
            targetDoc.head.appendChild(newLinkEl);
         }
      } catch (e) {
         console.error(e);
      }
   });
}

function isCssStyleSheet(styleSheet: unknown): styleSheet is CSSStyleSheet {
   return (styleSheet as CSSStyleSheet).cssRules !== undefined;
}
